module.exports = __webpack_public_path__ + "static/media/jsd-logo.637ec2ea.png";